export const CREATE_ATTENDANCE_SETTING = "CREATE_ATTENDANCE_SETTING";
export const FETCH_ATTENDANCE_SETTINGS = "FETCH_ATTENDANCE_SETTINGS";
export const EDIT_ATTENDANCE_SETTING = "EDIT_ATTENDANCE_SETTING";
